﻿var url = require("@cirrus/legacy/app-common/utils/url")

var Translator = function () {
  this.lang = null
  this.translationStrings = null
}

var loadTranslations = function (lang, callback) {
  $.ajax({
    url: url.api("/api/v1/translations"),
    type: "GET",
    data: {
      lang: lang,
    },
    async: false,
  }).success(function (data) {
    if (callback) callback(data)
  })
}

Translator.prototype.load = function (lang, callback) {
  var ctx = this

  loadTranslations(lang, function (data) {
    ctx.translationStrings = data
    if (callback) callback(data)
  })
}

Translator.prototype.get = function (key, ns, defaultText) {
  var value = App.lang ? App.lang + "-js-" + ns + ":" + key : this.lang + "-js-" + ns + ":" + key

  if (!this.translationStrings || !_.size(this.translationStrings)) {
    return ns + ":" + key
  }

  if (!this.translationStrings[ns] || !this.translationStrings[ns][key]) {
    return defaultText || value
  } else {
    return this.translationStrings[ns][key]
  }
}

Translator.prototype.hardcoded = function (input) {
  return input
}

Translator.prototype.translateKey = function (key) {
  var parts = key.split(":")
  return this.get(parts[1], parts[0])
}

Translator.prototype.get2 = function (key, defaultText) {
  if (key == null || !key.split) {
    return defaultText
  }

  var parts = key.split(":")

  if (parts[0] == null || parts[1] == null) {
    return defaultText
  }

  return this.get(parts[1], parts[0], defaultText)
}

Translator.prototype.getGeneral = function (key) {
  return this.get(key, this.generalns)
}

module.exports = {
  createTranslator: function (lang, callback) {
    var translator = new Translator()
    if (!lang) return translator

    translator.load(lang, callback)
    return translator
  },

  // Format like in C#
  format: function (str) {
    try {
      var formatAgs = Array.prototype.slice.call(arguments, 1, arguments.length)

      if (Object.prototype.toString.call(formatAgs[0]) === "[object Array]") {
        formatAgs = formatAgs[0]
      }

      for (i = 0; i < formatAgs.length; i++) {
        str = str.replace("{" + i + "}", formatAgs[i])
      }
      return str
    } catch (e) {
      return str
    }
  },
}
